/**
 * 首页标题1
 */

import { Row, Col } from 'antd';

const HH1 = () => {
    return <>
        <Row>
            <Col offset={4} span={16} style={{ textAlign: 'center' }}>
                <h1>精品服务</h1>
                <p>信息系统运维、咨询、集成，数据中心运维，安全风险管理</p>
            </Col>
        </Row>
    </>
}

export default HH1;